module.exports = __webpack_public_path__ + "static/media/review-carousel.0fc994bd.png";